'use client';

import Image from 'next/image';

import useDevice from '@/hooks/useDevice';

import css from './style.module.scss';

const BrandBookCurvedBlock = () => {
	const device = useDevice();

	return (
		<div className={css.curvedBlock}>
			<Image
				className={css.chubs}
				width={3303}
				height={2083}
				src="/assets/images/brand-book/chub-sprite.png"
				alt=""
			/>
			<div className={css.curvedWrapper}>
				<div className={css.curvedContainer}>
					<div>
						<Image
							width={1775}
							height={1775}
							src="/assets/images/circle-mask.svg"
							alt=""
							className={css.curvedMask}
						/>
					</div>
				</div>

				<div className={css.curvedContainer}>
					<Image
						width={device === 'desktop' ? 1775 : 424}
						height={device === 'desktop' ? 1775 : 424}
						alt=""
						className={css.curvedText}
						src={
							device === 'desktop'
								? '/assets/images/circle-text-desk.webp'
								: '/assets/images/circle-text-mobile.webp'
						}
					/>
				</div>
			</div>
		</div>
	);
};

export default BrandBookCurvedBlock;
